export const canProbeMediaDuration = (file: File, canPlayType: (mimeType: string) => CanPlayTypeResult): boolean => {
  if (file.name.toLowerCase().endsWith('.trm')) {
    return false;
  }

  if (!file.type.startsWith('audio/') && !file.type.startsWith('video/')) {
    return false;
  }

  return canPlayType(file.type) !== '';
};
